export default "__VITE_ASSET__DUwAwvWk__"